import React from 'react'

function HumanRersourceView() {
    return (
        <div>HumanRersourceView</div>
    )
}

export default HumanRersourceView